// The notification inbox is served by rtc, behind the same gateway as every
// other call. Pages are 1-based numbers, not cursors; a page past the end is a
// 200 with an empty list, not an error.

export const INBOX_NOTIFICATIONS = '/api/v1/rtc/inbox/notifications';
export const INBOX_UNREAD_COUNT = '/api/v1/rtc/inbox/unread-count';
export const INBOX_READ_ALL = '/api/v1/rtc/inbox/read-all';

/** Idempotent; 404 when the id doesn't exist or belongs to another user. */
export const inboxReadNotificationUrl = (notificationId: string) =>
  `/api/v1/rtc/inbox/notifications/${notificationId}/read`;

export const INBOX_PAGE_SIZE = 20;

/**
 * The inbox socket sits behind the same gateway as the REST routes, so its
 * address is derived from the API base rather than configured per environment.
 */
export const INBOX_SOCKET_PATH = '/api/v1/rtc/inbox/ws';

/**
 * The bell dropdown shows only the head of the first page — `مشاهده همه` leads
 * to the inbox page, which is where paging happens.
 */
export const INBOX_PANEL_PAGE_SIZE = 5;
